import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatChipsModule } from '@angular/material/chips'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'

import { CustomFieldModule } from '../custom-field'
import { ChipsSelectorInputComponent } from './chips-selector.component'

@NgModule({
  imports: [
    CustomFieldModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  declarations: [ChipsSelectorInputComponent],
  exports: [ChipsSelectorInputComponent],
})
export class ChipsSelectorModule {}
